import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 0.570801C16.712 0.865134 16.4177 1.15434 16.1377 1.45642C16.0488 1.55233 15.9239 1.69006 15.7749 1.8623C15.4779 2.20568 15.0805 2.69188 14.6811 3.26193C13.9214 4.34607 13 5.94519 13 7.49985C13 9.70899 14.7909 11.4999 17 11.4999C19.2091 11.4999 21 9.709 21 7.49986C21 5.94532 20.0786 4.3462 19.319 3.26205C18.9195 2.69199 18.5221 2.20577 18.2251 1.86237C18.0762 1.69011 17.9512 1.55238 17.8623 1.45646C17.5824 1.15437 17.2881 0.865148 17 0.570801ZM8.43505 13.2499C8.27075 13.2495 8.10797 13.2814 7.95605 13.344C7.80437 13.4065 7.66647 13.4982 7.55021 13.6139L5.5 15.6641V19.4999H11.1269L16.9306 18.0489L20.4625 16.5423C20.5462 16.4962 20.6167 16.4293 20.667 16.3478C20.7212 16.2602 20.7499 16.1593 20.75 16.0563C20.7499 15.9707 20.73 15.8862 20.692 15.8094C20.6539 15.7327 20.5986 15.6657 20.5305 15.6138C20.4623 15.5619 20.3831 15.5264 20.299 15.51C20.2149 15.4937 20.1282 15.497 20.0455 15.5196L20.0256 15.5251L13.6135 16.9999L10 16.9999V14.9999H13.125C13.3571 14.9998 13.5796 14.9077 13.7437 14.7436C13.9078 14.5795 14 14.3569 14 14.1249C14 13.8928 13.9078 13.6702 13.7437 13.5061C13.5796 13.342 13.3571 13.2499 13.125 13.2499H8.4375L8.43505 13.2499ZM15.9866 14.4018L19.5394 13.5847C19.9119 13.4862 20.3019 13.4732 20.6803 13.5467C21.0663 13.6217 21.4298 13.7846 21.7426 14.0229C22.0554 14.2612 22.309 14.5685 22.4837 14.9207C22.6584 15.273 22.7495 15.6608 22.75 16.054C22.7502 16.529 22.618 16.9954 22.3682 17.3995C22.1185 17.8035 21.761 18.1299 21.336 18.3421L21.3093 18.3554L17.5695 19.9508L11.3731 21.4999H0V14.2499H4.08579L6.13787 12.1978C6.44046 11.8962 6.79953 11.6573 7.19455 11.4947C7.58917 11.3322 8.01193 11.249 8.43868 11.2499L8.43995 11.2499L8.4375 11.2499H8.43868H13.125C13.8875 11.2499 14.6188 11.5528 15.1579 12.0919C15.6971 12.6311 16 13.3624 16 14.1249C16 14.2177 15.9955 14.3102 15.9866 14.4018ZM3.5 16.2499H2V19.4999H3.5V16.2499Z"}}]};

const UndertakeEnvironmentProtectionFilled = Vue.extend<IconProps>({
  name: 'UndertakeEnvironmentProtectionFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'undertake-environment-protection-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UndertakeEnvironmentProtectionFilled;
